import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useNavigate } from 'react-router-dom';
import SearchBar from '../components/search/SearchBar';
import Footer from '../components/layout/Footer';

const TICKER_LINES = [
  'Find out what other bands your favorite musicians have been in',
  'Discover new groups connected to the ones you already love',
  'Follow the lineup. Six degrees from your favorite artist',
];

const TickerCopy = () => (
  <>
    {TICKER_LINES.map((line) => (
      <span key={line} className="home-ticker-item">
        <span className="home-ticker-mark" aria-hidden="true">●</span>
        {line}
      </span>
    ))}
  </>
);

function HowItWorks({ onClose }) {
  useEffect(() => {
    const onKey = (event) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [onClose]);

  return createPortal(
    <div className="home-how-overlay" onClick={onClose} role="presentation">
      <div
        className="home-how"
        role="dialog"
        aria-modal="true"
        aria-labelledby="home-how-title"
        onClick={(event) => event.stopPropagation()}
      >
        <button
          type="button"
          className="home-how-close"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <p className="home-how-kicker">How it works</p>
        <h2 id="home-how-title">Band Bacon</h2>
        <ol className="home-how-steps">
          <li>Search a musician or band you already love.</li>
          <li>See the other groups they have been in, or those that share the same members.</li>
          <li>Discover new bands and musicians to love!</li>
        </ol>
        <button type="button" className="home-how-go" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>,
    document.body
  );
}

const Home = () => {
  const navigate = useNavigate();
  const [seeking, setSeeking] = useState(false);
  const [explainOpen, setExplainOpen] = useState(false);

  useEffect(() => {
    const root = document.documentElement;
    const sync = () => {
      const viewport = window.visualViewport;
      root.style.setProperty('--vv-height', `${viewport ? viewport.height : window.innerHeight}px`);
      root.style.setProperty('--vv-offset', `${viewport ? viewport.offsetTop : 0}px`);
    };
    sync();
    window.visualViewport?.addEventListener('resize', sync);
    window.visualViewport?.addEventListener('scroll', sync);
    window.addEventListener('resize', sync);
    return () => {
      window.visualViewport?.removeEventListener('resize', sync);
      window.visualViewport?.removeEventListener('scroll', sync);
      window.removeEventListener('resize', sync);
      root.style.removeProperty('--vv-height');
      root.style.removeProperty('--vv-offset');
    };
  }, []);

  const handleSearch = (id, name) => {
    if (id) {
      navigate(`/artist/${id}`, { state: { cueingName: name || '' } });
    }
  };

  return (
    <div className={`home-page ${seeking ? 'is-seeking' : ''}`}>
      <button
        type="button"
        className={`home-ticker ${explainOpen ? 'is-paused' : ''}`}
        onClick={() => setExplainOpen(true)}
        aria-label="How Band Bacon works"
      >
        <div className="home-ticker-track">
          <div className="home-ticker-set">
            <TickerCopy />
          </div>
          <div className="home-ticker-set" aria-hidden="true">
            <TickerCopy />
          </div>
        </div>
      </button>
      <div className="welcome-content">
        <p className="home-stamp">Discover new music</p>
        <h1>
          Six degrees of <span className="strikethrough">Kevin</span>
        </h1>
        <div className="home-logo">
          <span className="home-groove" aria-hidden="true"></span>
          <span className="home-groove home-groove-2" aria-hidden="true"></span>
          <img src="/images/logo-mask.png" alt="" className="logo-fill" width="800" height="125" aria-hidden="true" />
          <img src="/images/logo.png" alt="Band Bacon" className="logo-image" width="800" height="125" />
        </div>
        <div className="home-search-section">
          <SearchBar
            onSearch={handleSearch}
            onSeeking={setSeeking}
            placeholder="Search an artist or group"
          />
        </div>
      </div>
      <div className="home-footer-wrapper">
        <Footer />
      </div>
      {explainOpen && <HowItWorks onClose={() => setExplainOpen(false)} />}
    </div>
  );
};

export default Home;
